export const service = {
  enqueue: undefined,
};

const DELAY = 1000;
export function save(category, information, type, exceptionDetail) {
  setTimeout(() => {
    const informationList = Array.isArray(information) ? information : [information];
    if (service.enqueue) {
      informationList.forEach((info) => {
        service.enqueue({
          category,
          type,
          informationList: info,
          exceptionDetail,
        });
      });
    }
  }, DELAY);
}
